export function Loading(props) {
    return <div class="loader" title={props.resourceName}></div>;
}
;
